export const DOMAIN = "developer.ticktick.com";
